import templateUrl from "emun.media/media-gallery-item.htm";
import controller from "emun.media/media-gallery-item.controller";

export default {
	bindings: {
		mediaId: "@",
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	},
};
